import ReactGA from 'ga-4-react';
export const ga = new ReactGA('G-XMD2914GHX');
